import * as React from "react";

function IconLayoutOff({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-layout-off" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><desc>{"Download more icon variants from https://tabler-icons.io/i/layout-off"}</desc><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M8 4a2 2 0 0 1 2 2m-1.162 2.816a1.993 1.993 0 0 1 -.838 .184h-2a2 2 0 0 1 -2 -2v-1c0 -.549 .221 -1.046 .58 -1.407" /><rect x={4} y={13} width={6} height={7} rx={2} /><path d="M14 10v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v10m-.595 3.423a1.994 1.994 0 0 1 -1.405 .577h-2a2 2 0 0 1 -2 -2v-4" /><path d="M3 3l18 18" /></svg>;
}

export default IconLayoutOff;